import { createDraftSafeSelector, createSlice } from '@reduxjs/toolkit';
import { omit } from 'lodash';
import { listPageConfig } from 'src/config';
import { memoizePick } from 'src/utils/memoize-pick';

const initialState = {
  pageState: {
    view: 'list',
    page: 0,
    rowsPerPage: listPageConfig.rowPerpage,
    filters: {
      query: '',
      actived: 'all'
    },
    sortBy: 'createdAt',
    sortDir: 'desc'
  }
};

export const carModelSlice = createSlice({
  name: 'carModel',
  initialState,
  reducers: {
    resetState: () => initialState,
    resetPageState: (state) => {
      state.pageState = initialState.pageState;
    },
    resetPageStateForNewData: (state) => {
      state.pageState = { ...state.pageState, page: initialState.pageState.page, filters: initialState.pageState.filters };
    },
    changePageState: (state, action) => {
      state.pageState = { ...state.pageState, ...action.payload };
    },
    resetFilters: (state) => {
      state.pageState.filters = initialState.pageState.filters;
    },

    changeFilters: (state, action) => {
      state.pageState.filters = { ...state.pageState.filters, ...action.payload };
    },
    removeFilter: (state, action) => {
      state.pageState.filters = omit(state.pageState.filters, action.payload);
    }
  }
});

// Action creators are generated for each case reducer function
export const { resetState, resetPageState, resetPageStateForNewData, changePageState, resetFilters, changeFilters, removeFilter } =
  carModelSlice.actions;

// Selectors
export const selectCarModelPageState = ({ carModel }) => carModel.pageState;

export const selectCarModelPageStatePart = createDraftSafeSelector(
  selectCarModelPageState,
  (_, keys = []) => keys,
  (pageState, keys) => {
    console.log('selectCarModelPageStatePart state', pageState);
    return memoizePick(pageState, keys);
  }
);

export const selectCarModelPageStateView = ({ carModel }) => carModel.pageState.view;

// Reducer
export default carModelSlice.reducer;
